import { getSearch } from '../window';

const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/;

export const getCountryCode = (): string | undefined => {
  try {
    const params = new URLSearchParams(getSearch().substring(1));
    const value = params.get('countryCode') || undefined;
    if (value && COUNTRY_CODE_PATTERN.test(value)) {
      return value;
    }
    return undefined;
  } catch (e) {
    // IE fallback
    const match = getSearch().match(/countryCode=([A-Z]{2})(?:&|$)/)?.[1];
    return match || undefined;
  }
};
